import React, { useState } from "react";
import FooterPagesBackground from "../assets/FooterPagesBackground.webp";
import liggandebakrund from "../assets/liggandebakgrund.svg";
import "./css/Newsletterandshare.css";
import ToHomeBtn from "../components/Shared/ToHomepageBtn";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import FooterInsideSmallerPages from "./FooterInsideSmallerPages";

function NewsLetterAndShare() {
  const [email, setEmail] = useState("");
  const [emailForShare, setEmailForShare] = useState("")
  const [numberForShare, setNumberForShare] = useState("")

  const subscribeToNewsletter = async (e) => {
    e.preventDefault();

    const apiKey = process.env.REACT_APP_BREVO_API_KEY;
    const listId = 3;

    try {
      const response = await fetch("https://api.brevo.com/v3/contacts", {
        method: "POST",
        headers: {
          "api-key": apiKey,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email, listIds: [listId] }),
      });

      if (response.ok) {
        toast.success("Tack! " + email + " är nu prenumererad på vårt nyhetsbrev.", {
          position: "top-right", autoClose: 3000
        })
        setEmail("");
      } else {
        toast.error("Epostadressen är redan används", {
          position: "top-right", autoClose: 3000
        })
        setEmail("");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Ett fel uppstod, försök igen senare.", {
        position: "top-right", autoClose: 3000
      })
    }
  };

  return (
    <div className="newsletter-contact-form-container">
      < ToastContainer />
      <div
        className="newsletter-background-image"
        style={{ backgroundImage: `url(${liggandebakrund})` }}
      ></div>
      <div className="newsletter-content-container">
        <ToHomeBtn />
        <div className="newsletter-contact-sections">
          <div className="newsletter-contact-info">
            <h2>Dela hemsida</h2>
            <div className="newsletter-below-tittle-2">
              <div className="newsletter-field-and-button">
                <input
                  type="email"
                  placeholder="E-postadress"
                  value={emailForShare}
                  onChange={(e) => setEmailForShare(e.target.value)}
                  required
                />
                <button type="button" className="send-icon-button">
                  ✉️
                </button>
              </div>
              <div className="newsletter-field-and-button">
                <input
                  type="number"
                  placeholder="Telefonnummer"
                  value={numberForShare}
                  onChange={(e) => setNumberForShare(e.target.value)}
                  required
                />
                <button type="button" className="send-icon-button">
                  💬
                </button>
              </div>
              <div className="newsletter-social-icons">
                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg" alt="Facebook" />
                </a>
                <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" />
                </a>
                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png" alt="LinkedIn" />
                </a>
                <a
                  href="https://blueskyweb.xyz"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Bluesky_Logo.svg/600px-Bluesky_Logo.svg.png"
                    alt="BlueSky"
                  />
                </a>
                <a
                  href="https://threads.net"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Threads_%28app%29.svg/512px-Threads_%28app%29.svg.png"
                    alt="Threads"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="newsletter-contact-form">
            <h2>Nyhetsbrev</h2>
            <form onSubmit={subscribeToNewsletter}>
              <input
                type="email"
                placeholder="E-postadress"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <div className="newsletter-send-button-container">
                <button type="submit" className="newsletter-send-button">
                  Prenumerera
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <FooterInsideSmallerPages />
    </div>
  );
}

export default NewsLetterAndShare;